module.exports = __webpack_public_path__ + "static/media/oliver_and_heida.54221978.png";